import Cookies from 'js-cookie'

const TokenKey = 'lshoot-qupaipai-hkm-account-token'
const AllRoleKey = 'lshoot-qupaipai-hkm-account-roles'
const RoleKey = 'lshoot-qupaipai-hkm-account-curRole'
const OpenidKey = 'lshoot-qupaipai-hkm-account-openid'
const Domain = 'lshoot.com'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, expires) {
  //return Cookies.set(TokenKey, token, { expires: expires })
  // return Cookies.set(TokenKey, token)
  let topDomain = ''
  if (window.location.host.indexOf('localhost') === -1) {
    //topDomain = window.location.href.replace(/.+[\.\/]([A-z0-9]+\.[A-z0-9]+)\/[^\/].+/, '$1')
    topDomain = Domain
  }
  if (window.location.host.indexOf('192.168.') > -1) {
    topDomain = window.location.host.split(':')[0]
  }
  console.info('expires', token, expires, topDomain)
  return Cookies.set(TokenKey, token, { expires: new Date(new Date(expires).getTime() + 8 * 60 * 60 * 1000), domain: topDomain });
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getCurRole() {
  return Cookies.get(RoleKey)
}

export function getAllRoles() {
  return Cookies.get(AllRoleKey)
}

export function setRole(roles, curRole, expires) {
  let topDomain = ''
  if (window.location.host.indexOf('localhost') === -1) {
    //topDomain = window.location.href.replace(/.+[\.\/]([A-z0-9]+\.[A-z0-9]+)\/[^\/].+/, '$1')
    topDomain = Domain
  }
  if (window.location.host.indexOf('192.168.') > -1) {
    topDomain = window.location.host.split(':')[0]
  }
  console.info('expires', curRole, expires, topDomain)
  if (roles) {
    Cookies.set(AllRoleKey, roles, { expires: new Date(new Date(expires).getTime() + 8 * 60 * 60 * 1000), domain: topDomain });
  }
  Cookies.set(RoleKey, curRole, { expires: new Date(new Date(expires).getTime() + 8 * 60 * 60 * 1000), domain: topDomain });
}

export function getOpenid() {
  return Cookies.get(OpenidKey)
}

export function setOpenid(openid, expires) {
  //return Cookies.set(TokenKey, openid, { expires: expires })
  // return Cookies.set(TokenKey, openid)
  let topDomain = ''
  if (window.location.host.indexOf('localhost') === -1) {
    //topDomain = window.location.href.replace(/.+[\.\/]([A-z0-9]+\.[A-z0-9]+)\/[^\/].+/, '$1')
    topDomain = Domain
  }
  if (window.location.host.indexOf('192.168.') > -1) {
    topDomain = window.location.host.split(':')[0]
  }
  console.info('expires', openid, expires, topDomain)
  return Cookies.set(OpenidKey, openid, { expires: new Date(new Date(expires).getTime() + 8 * 60 * 60 * 1000), domain: topDomain });
}


// WEBPACK FOOTER //
// ./src/utils/auth.js